import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';

const Container = styled.div`
  margin-bottom: ${spacing.base};
`;

const displayContent = {
  trackingDomainsVerificationErrors: 'Tracking domain verification errors',
};

type Props = {
  /** [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json */
  content?: {
    trackingDomainsVerificationErrors: string;
  };
  verificationErrors: string[];
};

export const VerificationErrors = ({
  content = displayContent,
  verificationErrors = [],
}: Props): JSX.Element => {
  return (
    <Container>
      <WarningBanner
        data-test="mail-domains-warning-banner"
        title={content.trackingDomainsVerificationErrors}
      >
        {verificationErrors.map((error) => (
          <div key={error}>{error}</div>
        ))}
      </WarningBanner>
    </Container>
  );
};
